<app-case-study-hero [artData]="pageData"></app-case-study-hero>
<app-case-study-api [artData]="pageData"></app-case-study-api>
<app-case-study-stories [artData]="pageData"></app-case-study-stories>
<app-common-getstarted
  [getStartedData]="getStartedData"
></app-common-getstarted>
